// extracted by mini-css-extract-plugin
module.exports = {"root":"_4ec3c3","container":"_03a2a8","item":"_bb9c26","itemQuantity":"_2a97dd","itemDescription":"_e2f5d2","logo":"_c5d829"};